import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import DeviceCellRenderer from "./CustomCells/DeviceCellRenderer";

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
  getFilteredData?: Function;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, searchVal, openModal,getFilteredData }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [allRows, setAllRows] = useState<any[]>([]);
  const [original, setOriginal] = useState<any[]>([]);

  // filters table for when user types in search value
  useEffect(() => {
    if (searchVal && searchVal !== "") {
        let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);



  var dateFilterParams = {
    comparator: function (filterLocalDateAtMidnight: any, cellValue: any) {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('/');
      var cellDate = new Date(
        Number(dateParts[2].includes(',') ? dateParts[2].split(',')[0] : dateParts[2].split(' ')[0]),
        Number(dateParts[0]) - 1,
        Number(dateParts[1])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    minValidYear: 2000,
    maxValidYear: new Date().getFullYear()
  };

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      //console.log(flatData);
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];

      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = null;

        if (keys[i] === "deviceId") {
          obj = {
            headerName: 'Device ID', field: keys[i],
                  cellRendererSelector: (params: any) => {
              return { component: DeviceCellRenderer }
            },
                  cellRendererParams: openModal ?
                      {
                deleteAction: (modal: any, user: any) => openModal(modal, user),
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
        }
        else if (keys[i] === "deviceTypeName") {
          obj = { headerName: 'Device Type', field: keys[i] }
          }
        else if (keys[i] === "deviceStatus") {
          obj = { headerName: 'Device Status', field: keys[i] }
        }
        else if (keys[i] === "application") {
          obj = { headerName: 'Application', field: keys[i] }
          }
        else if (keys[i] === "serviceProviderNme") {
          obj = { headerName: 'Service Provider Name', field: keys[i], width: 220 }
          }
        else if (keys[i] === "segmentName") {
          obj = { headerName: 'Segment Name', field: keys[i] }
          }
        else if (keys[i] === "observation1Description") {
          obj = { headerName: 'Observation 1 Description', field: keys[i], width: 300 }
        }
        else if (keys[i] === "observation2Description") {
          obj = { headerName: 'Observation 2 Description', field: keys[i], width: 300 }
        }
        else if (keys[i] === "observation3Description") {
          obj = { headerName: 'Observation 3 Description', field: keys[i], width: 300 }
        }
        else  if (keys[i] === "creationDate") {
          obj = { headerName: 'Created Date', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else  if (keys[i] === "createdBy") {
          obj = { headerName: 'Created By', field: keys[i] }
        }
        else  if (keys[i] === "lastUpdateDate") {
          obj = { headerName: 'Last Updated Date', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else  if (keys[i] === "lastUpdatedBy") {
          obj = { headerName: 'Last Updated By', field: keys[i] }
            }
        else if (keys[i] === "truckName") {
          obj = { headerName: 'Truck Number', field: keys[i] }
        }
        else if (keys[i] === "lastReportedTipTime") {
          obj = { headerName: 'Last Tip Timestamp', width: 240,field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "lastReportedHeartbeatTime") {
          obj = { headerName: 'Last Heartbeat Timestamp', width: 240,field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        if (obj) {
            if (keys[i] === "deviceId")
              newKeys.unshift(obj);
            else 
              newKeys.push(obj);
            }
          
        // }
      }

      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
      setAllRows(newRows);
    }
    else { // this values are shown when list is empty
      setRows([]);
      setOriginal([]);
      setColumns([
        { headerName: 'Device ID' },
        { headerName: 'Device Type' },
        { headerName: 'Device Status' },
        { headerName: 'Application' },
        { headerName: 'Service Provider Name' },
        { headerName: 'Segment Name' },
        { headerName: 'Observation 1 Description' },
        { headerName: 'Observation 2 Description' },
        { headerName: 'Observation 3 Description' },
        { headerName: 'Last Reported Event Time(User Timezone)' },
        { headerName: 'Last Reported Event Type' },
        { headerName: 'Created Date' },
        { headerName: 'Created By' },
        { headerName: 'Last Updated Date' },
        { headerName: 'Last Updated By' },
        { headerName: 'Truck Number' }
      ]);
        setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: true,
    filter: 'agSetColumnFilter',
    resizable: true
  };

    // Downloading Only Filtered Data After Search
    useEffect(() => {
      if (getFilteredData)
        getFilteredData(rows);
    },[rows]);

  return (
    <Box className="ag-theme-material" sx={{ height: "100%", width: '100%' }}>
      <AgGridReact
        defaultColDef={defaultColDef}
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={100}
        suppressHorizontalScroll={false}
        suppressPreventDefaultOnMouseWheel={true}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default TableComponent;
